import './Notification.css';
export const Notification = ({ icon, title, desc, handleSubmit, hasBtn = true, btnText = '확인', guide, btnType = 'primary' }) => {
  return (
    <div className='container-wrap complete'>
      <div className='content-area'>
        <div className='center-content'>
          <div className='icon-wrap'>{icon}</div>
          <div className='main-text-wrap'>
            <h3>{title}</h3>
            <p>{desc}</p>
          </div>
        </div>
      </div>
      {/* 안내 회색 박스 */}
      {guide && (
        <div className='info-box'>
          <div>
            <h3>안내 사항</h3>
            <ul>
              {guide.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
      {hasBtn && (
        <div className='btm-area default-btm'>
          <button type='button' className={`btn btm-btn-${btnType}`} onClick={handleSubmit}>
            <span className='btn-txt-01'>{btnText}</span>
          </button>
        </div>
      )}
    </div>
  );
};
